import { DatePicker, Tooltip } from "antd";
import { useEffect, useState } from "react";
import { BiSearch } from "react-icons/bi";
import { FiArrowDown, FiArrowUp, FiFilter } from "react-icons/fi";
import { IoCloseSharp } from "react-icons/io5";
import { Button, Dropdown, DropdownItem, DropdownMenu, DropdownToggle, Spinner } from "reactstrap";
import { useSelector } from "react-redux";
import { TbLayoutSidebarRightCollapse, TbLayoutSidebarRightExpand } from "react-icons/tb";
import { RiFileList3Line } from "react-icons/ri";
import GeneralButton from "../../../components/button/GeneralButton";
import FormInput from "../../../components/formInput/FormInput";
import CreateNewOrderModal from "../../../components/modals/CreateNewOrderModal";
import { orderStatuses, paymentStatuses } from "../../../data";
import useRowSelection from "../../../views/Admin/customHooks/useRowSelection";
import { GlobalHeader } from "../../Headers/Headers";
import { SelectInputDropdown } from "../../dropdown/DropDown";
import PayForOrderModal from "../../modals/PayForOrderModal";
const { RangePicker } = DatePicker;
const SaleOrderHeader = ({
  searchValue,
  setSearchValue,
  setSelectedOrderStatus,
  setSelectedPaymentStatus,
  setCanSearch,
  selectedData,
  setSelectedData,
  selectedOrderStatus,
  user,
  dateRange,
  setDateRange,
  length,
  handleCriticalOrderClick,
  showCriticalOrders,
  criticalOrders,
  loading,
  gettingOrders,
  sortOrder,
  setSortOrder,
  toggleDrawer,
  isRecentPoOpen,
  toggleNavbarDrawer,
}) => {
  const { layout } = useSelector((state) => state.redux);
  const { setCurrentPage } = useRowSelection();
  // MODALS
  const [modal, setModal] = useState(false);
  const toggleCreateOrder = () => setModal(!modal);
  const [payModal, setPayModal] = useState(false);
  const togglePayOrder = () => setPayModal(!payModal);
  const [filterDropdownOpen, setFilterDropdownOpen] = useState(false);
  const [searchHistory, setSearchHistory] = useState(() => {
    try {
      const history = localStorage.getItem("saleOrderSearchHistory");
      if (!history) return [];
      const parsed = JSON.parse(history);
      const now = Date.now();
      // Filter out items older than 1 hour (3,600,000 ms)
      return parsed.filter(item => item.timestamp && (now - item.timestamp < 3600000));
    } catch (e) {
      return [];
    }
  });
  const [showHistory, setShowHistory] = useState(false);

  // Effect to clean up history every minute
  useEffect(() => {
    const interval = setInterval(() => {
      setSearchHistory(prev => {
        const now = Date.now();
        const filtered = prev.filter(item => item.timestamp && (now - item.timestamp < 3600000));
        if (filtered.length !== prev.length) {
          localStorage.setItem("saleOrderSearchHistory", JSON.stringify(filtered));
        }
        return filtered;
      });
    }, 60000); // Check every minute
    return () => clearInterval(interval);
  }, []);

  const clearSearch = () => {
    setSearchValue("");
    localStorage.removeItem("search");
    setCanSearch(true);
    setCurrentPage(1);
  };

  const saveToHistory = (term) => {
    const cleanTerm = term?.trim();
    if (!cleanTerm || cleanTerm.length < 2) return;

    // Use a function to get the latest state or read from localStorage directly
    setSearchHistory((prev) => {
      const currentHistory = Array.isArray(prev) ? prev : [];
      const now = Date.now();
      const newHistory = [
        { term: cleanTerm, timestamp: now },
        ...currentHistory.filter((item) => item.term !== cleanTerm)
      ].slice(0, 10);
      localStorage.setItem("saleOrderSearchHistory", JSON.stringify(newHistory));
      return newHistory;
    });
  };

  // Auto-save history after 2 seconds of typing inactivity
  useEffect(() => {
    if (searchValue && searchValue.trim().length >= 3) {
      const timer = setTimeout(() => {
        saveToHistory(searchValue);
      }, 2000);
      return () => clearTimeout(timer);
    }
  }, [searchValue]);

  const handleHistoryClick = (term) => {
    setSearchValue(term);
    setCanSearch(true);
    setCurrentPage(1);
    localStorage.setItem("search", term);
    setShowHistory(false);
    saveToHistory(term); // Move to top of history
  };

  const clearHistory = (e) => {
    e.stopPropagation();
    setSearchHistory([]);
    localStorage.removeItem("saleOrderSearchHistory");
  };

  return (
    <>
      <CreateNewOrderModal modal={modal} toggle={toggleCreateOrder} />
      <PayForOrderModal
        modal={payModal}
        toggle={togglePayOrder}
        selectedData={selectedData}
      />
      <div className="sales">
        <div className="d-flex justify-content-between align-items-center">
          <div className="d-flex align-items-center gap-3">
            <div>
              <SelectInputDropdown
                type={"select"}
                placeholder={"All Orders"}
                options={orderStatuses}
                className={"saleOrderDropdown"}
                handleChange={(e) => {
                  setCanSearch(true);
                  setSelectedOrderStatus(e.target.value);
                  setCurrentPage(1);
                  localStorage.setItem("selectedOrderStatus", e.target.value);
                  localStorage.setItem("saleOrderPage", 1);
                  setDateRange([]);
                }}
                value={selectedOrderStatus}
              />
            </div>
            <div>
              <SelectInputDropdown
                type={"select"}
                placeholder={"All Payments Status"}
                options={paymentStatuses}
                className={"saleOrderDropdown"}
                handleChange={(e) => {
                  setCanSearch(true);
                  setSelectedPaymentStatus(e.target.value);
                  setDateRange([]);
                }}
              />
            </div>

            <div className="text-muted small fw-bold">{`Orders: ${length ?? 0}`}</div>
          </div>


        </div>
        <div className="d-lg-flex justify-content-between my-2">
          <div className="d-flex align-items-center">

            <div className="position-relative" style={{ width: '300px' }}>
              <FormInput
                type={"text"}
                placeholder={"Search order ID / status / SKU number "}
                className={`border border-1 rounded-0 mb-0`}
                size={"large"}
                icon={<BiSearch size={"20"} style={{ color: "#B0B0B0" }} />}
                handleChange={(e) => {
                  setCurrentPage(1);
                  localStorage.setItem("saleOrderPage", 1);
                  setCanSearch(true);
                  setSearchValue(e.target.value);
                  localStorage.setItem("search", e.target.value);
                }}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    saveToHistory(searchValue);
                    setShowHistory(false);
                  }
                }}
                onFocus={() => setShowHistory(true)}

                onBlur={() => {
                  setTimeout(() => setShowHistory(false), 200);
                }}
                value={searchValue}
                suffix={
                  searchValue ? (
                    <IoCloseSharp
                      size={18}
                      className="text-muted pointer"
                      onClick={clearSearch}
                    />
                  ) : null
                }
              />

              {showHistory && searchHistory.length > 0 && (
                <div
                  className="position-absolute w-100 bg-white border shadow-lg mt-1"
                  style={{
                    zIndex: 2000,
                    borderRadius: '4px',
                    maxHeight: '300px',
                    overflowY: 'auto',
                    top: '100%',
                    left: 0
                  }}
                >
                  <div className="d-flex justify-content-between align-items-center p-2 border-bottom bg-light sticky-top">
                    <span className="text-muted small fw-bold">RECENT SEARCHES</span>
                    <span
                      className="text-primary small cursor-pointer fw-bold"
                      onClick={clearHistory}
                      style={{ cursor: 'pointer' }}
                    >
                      Clear All
                    </span>
                  </div>
                  {searchHistory.map((item, index) => (
                    <div
                      key={index}
                      className="d-flex align-items-center p-2 border-bottom"
                      style={{ cursor: 'pointer', transition: 'background 0.2s' }}
                      onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f8f9fa'}
                      onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'transparent'}
                      onClick={() => handleHistoryClick(item.term)}
                    >
                      <BiSearch size={16} className="text-muted me-2" />
                      <span className="flex-grow-1" style={{ fontSize: '14px', color: '#333' }}>{item.term}</span>
                    </div>
                  ))}
                </div>
              )}
            </div>
            {(user?.role === "Admin" || user?.role === "Super-admin") && selectedData?.length > 0 && (
              <GlobalHeader
                selectedData={selectedData}
                setSelectedData={setSelectedData}
                collection={"Orders"}
                term={"Order"}
                items={["Cancel", "Paid", "Delete"]}
                callftn={gettingOrders}
              />
            )}
            <div className="d-flex align-items-center justify-content-center">
              <div className="mx-2">
                <GeneralButton
                  title={"Pay For Orders"}
                  className={
                    "bg-secondary-color text-black border border-1  mb-3 rounded-0"
                  }
                  width={"150px"}
                  handleClick={togglePayOrder}
                />
              </div>
              <div className="mb-3 primary-color">
                {loading && <Spinner size={"md"} />}
              </div>
            </div>
          </div>

          <div className="d-flex align-items-center  mb-3">
            <Dropdown
              className="mx-2 rounded-0"
              isOpen={filterDropdownOpen}
              toggle={() => setFilterDropdownOpen(!filterDropdownOpen)}
            >
              <DropdownToggle
                className="bg-white border-1 text-dark shadow-sm px-2 d-flex align-items-center gap-2 rounded-8"
                caret
                style={{ height: '40px', borderColor: '#d0d5dd' }}
              >
                <FiFilter size={16} className="text-primary" />
                <span style={{ fontSize: '13px', fontWeight: 600 }}>Sort & Filter</span>
              </DropdownToggle>
              <DropdownMenu className="shadow-lg border-0 rounded-8 p-3" end style={{ minWidth: '320px' }}>
                <div className="px-2 mb-2 text-muted small fw-bold text-uppercase">Sorting</div>
                <DropdownItem
                  className={`rounded-8 py-2 d-flex align-items-center gap-2 ${sortOrder === "desc" ? "bg-primary-soft text-primary" : ""}`}
                  onClick={() => setSortOrder("desc")}
                >
                  <FiArrowDown size={14} /> Newest First
                </DropdownItem>
                <DropdownItem
                  className={`rounded-8 py-2 d-flex align-items-center gap-2 ${sortOrder === "asc" ? "bg-primary-soft text-primary" : ""}`}
                  onClick={() => setSortOrder("asc")}
                >
                  <FiArrowUp size={14} /> Oldest First
                </DropdownItem>

                <DropdownItem divider />

                <div className="px-2 mb-2 text-muted small fw-bold text-uppercase">Date Range</div>
                <DropdownItem toggle={false} className="p-0 bg-transparent border-0">
                  <div className="px-2 pb-2" onClick={(e) => e.stopPropagation()}>
                    <RangePicker
                      value={dateRange}
                      format={"YYYY/MM/DD"}
                      className="w-100 rounded-8"
                      style={{ height: '38px' }}
                      getPopupContainer={(trigger) => trigger.parentElement}
                      onChange={(date, dateString) => {
                        if (dateString[0] && dateString[1]) {
                          localStorage.setItem("dateRange", dateString);
                        } else {
                          localStorage.removeItem("dateRange");
                        }
                        setDateRange(date);
                      }}
                    />
                  </div>
                </DropdownItem>

                {dateRange && dateRange.length > 0 && (
                  <DropdownItem
                    toggle={false}
                    className="text-danger small py-2 rounded-8 mt-2"
                    onClick={() => {
                      setDateRange(null);
                      localStorage.removeItem("dateRange");
                    }}
                  >
                    Clear Date Filter
                  </DropdownItem>
                )}
              </DropdownMenu>
            </Dropdown>
            <Button
              // color="primary"
              className="bg-danger border-0 rounded-0"
              size=""
              onClick={handleCriticalOrderClick}
            >
              {showCriticalOrders
                ? "Hide Critical Orders"
                : "Show Critical Orders "}{" "}
              ({criticalOrders})
            </Button>
            {layout !== "navbar" ? (
              <Tooltip title="View Recent Purchase Orders Drawer" placement="bottom">
                <Button
                  color="primary"
                  onClick={toggleDrawer}
                  className="d-flex align-items-center gap-2 mx-2 border-0 rounded-1 shadow-sm"
                  style={{ height: '38px', backgroundColor: '#1890ff', fontWeight: 500 }}
                >
                  <RiFileList3Line size={18} />
                  <span>Recent POs</span>
                </Button>
              </Tooltip>
            ) : (
              <Tooltip
                title={isRecentPoOpen ? "Collapse Recent Purchase Orders Panel" : "Expand Recent Purchase Orders Panel"}
                placement="bottom"
              >
                <button
                  type="button"
                  className={`mx-2 d-flex align-items-center gap-2 px-3 py-1 transition-all ${
                    isRecentPoOpen
                      ? "btn btn-primary text-white shadow-sm"
                      : "btn btn-outline-secondary bg-white text-dark shadow-sm"
                  }`}
                  style={{
                    height: '38px',
                    borderRadius: '6px',
                    fontWeight: 500,
                    fontSize: '13px',
                    border: isRecentPoOpen ? '1px solid #1890ff' : '1px solid #d0d5dd',
                    backgroundColor: isRecentPoOpen ? '#1890ff' : '#ffffff',
                    cursor: 'pointer'
                  }}
                  onClick={toggleNavbarDrawer}
                  aria-expanded={isRecentPoOpen}
                  aria-label={isRecentPoOpen ? "Collapse Recent POs Panel" : "Expand Recent POs Panel"}
                >
                  {isRecentPoOpen ? (
                    <TbLayoutSidebarRightCollapse size={18} />
                  ) : (
                    <TbLayoutSidebarRightExpand size={18} />
                  )}
                  <span className="d-none d-md-inline">Recent POs</span>
                </button>
              </Tooltip>
            )}
            <GeneralButton
              title={"Create Order"}
              className={" mx-2 border-0 bg-primary-color rounded-0"}
              width={"150px"}
              handleClick={() => {
                toggleCreateOrder();
              }}
            />
          </div>
        </div>
      </div>
    </>
  );
};
export default SaleOrderHeader;
